// source: io/codedrills/proto/user/dashboard.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var io_codedrills_proto_content_view_pb = require('../../../../io/codedrills/proto/content/view_pb.js');
goog.object.extend(proto, io_codedrills_proto_content_view_pb);
goog.exportSymbol('proto.io.codedrills.proto.user.CodeAnalysis', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.CodeAnalysisView', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.Dashboard', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.DashboardView', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.OverAllStatus', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.OverAllStatusView', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.TopicStatus', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.TopicStatusView', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.Dashboard = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.user.Dashboard.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.user.Dashboard, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.Dashboard.displayName = 'proto.io.codedrills.proto.user.Dashboard';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.DashboardView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.user.DashboardView.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.user.DashboardView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.DashboardView.displayName = 'proto.io.codedrills.proto.user.DashboardView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.TopicStatusView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.TopicStatusView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.TopicStatusView.displayName = 'proto.io.codedrills.proto.user.TopicStatusView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.CodeAnalysisView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.CodeAnalysisView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.CodeAnalysisView.displayName = 'proto.io.codedrills.proto.user.CodeAnalysisView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.OverAllStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.OverAllStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.OverAllStatus.displayName = 'proto.io.codedrills.proto.user.OverAllStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.OverAllStatusView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.OverAllStatusView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.OverAllStatusView.displayName = 'proto.io.codedrills.proto.user.OverAllStatusView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.TopicStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.TopicStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.TopicStatus.displayName = 'proto.io.codedrills.proto.user.TopicStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.CodeAnalysis = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.CodeAnalysis, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.CodeAnalysis.displayName = 'proto.io.codedrills.proto.user.CodeAnalysis';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.user.Dashboard.repeatedFields_ = [2,3,4,5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.Dashboard.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.Dashboard.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.Dashboard} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Dashboard.toObject = function(includeInstance, msg) {
  var f, obj = {
    overAllStatus: (f = msg.getOverAllStatus()) && proto.io.codedrills.proto.user.OverAllStatus.toObject(includeInstance, f),
    inProgressDrillIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    strengthsList: jspb.Message.toObjectList(msg.getStrengthsList(),
    proto.io.codedrills.proto.user.TopicStatus.toObject, includeInstance),
    weaknessesList: jspb.Message.toObjectList(msg.getWeaknessesList(),
    proto.io.codedrills.proto.user.TopicStatus.toObject, includeInstance),
    codeAnalysisList: jspb.Message.toObjectList(msg.getCodeAnalysisList(),
    proto.io.codedrills.proto.user.CodeAnalysis.toObject, includeInstance),
    recommendedProblemIdsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.Dashboard}
 */
proto.io.codedrills.proto.user.Dashboard.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.Dashboard;
  return proto.io.codedrills.proto.user.Dashboard.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.Dashboard} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.Dashboard}
 */
proto.io.codedrills.proto.user.Dashboard.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.io.codedrills.proto.user.OverAllStatus;
      reader.readMessage(value,proto.io.codedrills.proto.user.OverAllStatus.deserializeBinaryFromReader);
      msg.setOverAllStatus(value);
      break;
    case 2:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setInProgressDrillIdsList(value);
      break;
    case 3:
      var value = new proto.io.codedrills.proto.user.TopicStatus;
      reader.readMessage(value,proto.io.codedrills.proto.user.TopicStatus.deserializeBinaryFromReader);
      msg.addStrengths(value);
      break;
    case 4:
      var value = new proto.io.codedrills.proto.user.TopicStatus;
      reader.readMessage(value,proto.io.codedrills.proto.user.TopicStatus.deserializeBinaryFromReader);
      msg.addWeaknesses(value);
      break;
    case 5:
      var value = new proto.io.codedrills.proto.user.CodeAnalysis;
      reader.readMessage(value,proto.io.codedrills.proto.user.CodeAnalysis.deserializeBinaryFromReader);
      msg.addCodeAnalysis(value);
      break;
    case 6:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setRecommendedProblemIdsList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.Dashboard.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.Dashboard.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.Dashboard} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Dashboard.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOverAllStatus();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.io.codedrills.proto.user.OverAllStatus.serializeBinaryToWriter
    );
  }
  f = message.getInProgressDrillIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      2,
      f
    );
  }
  f = message.getStrengthsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.io.codedrills.proto.user.TopicStatus.serializeBinaryToWriter
    );
  }
  f = message.getWeaknessesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.io.codedrills.proto.user.TopicStatus.serializeBinaryToWriter
    );
  }
  f = message.getCodeAnalysisList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.io.codedrills.proto.user.CodeAnalysis.serializeBinaryToWriter
    );
  }
  f = message.getRecommendedProblemIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      6,
      f
    );
  }
};


/**
 * optional OverAllStatus over_all_status = 1;
 * @return {?proto.io.codedrills.proto.user.OverAllStatus}
 */
proto.io.codedrills.proto.user.Dashboard.prototype.getOverAllStatus = function() {
  return /** @type{?proto.io.codedrills.proto.user.OverAllStatus} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.OverAllStatus, 1));
};


/**
 * @param {?proto.io.codedrills.proto.user.OverAllStatus|undefined} value
 * @return {!proto.io.codedrills.proto.user.Dashboard} returns this
*/
proto.io.codedrills.proto.user.Dashboard.prototype.setOverAllStatus = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.Dashboard} returns this
 */
proto.io.codedrills.proto.user.Dashboard.prototype.clearOverAllStatus = function() {
  return this.setOverAllStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.Dashboard.prototype.hasOverAllStatus = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated int32 in_progress_drill_ids = 2;
 * @return {!Array<number>}
 */
proto.io.codedrills.proto.user.Dashboard.prototype.getInProgressDrillIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.io.codedrills.proto.user.Dashboard} returns this
 */
proto.io.codedrills.proto.user.Dashboard.prototype.setInProgressDrillIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.Dashboard} returns this
 */
proto.io.codedrills.proto.user.Dashboard.prototype.addInProgressDrillIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.Dashboard} returns this
 */
proto.io.codedrills.proto.user.Dashboard.prototype.clearInProgressDrillIdsList = function() {
  return this.setInProgressDrillIdsList([]);
};


/**
 * repeated TopicStatus strengths = 3;
 * @return {!Array<!proto.io.codedrills.proto.user.TopicStatus>}
 */
proto.io.codedrills.proto.user.Dashboard.prototype.getStrengthsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.user.TopicStatus>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.user.TopicStatus, 3));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.user.TopicStatus>} value
 * @return {!proto.io.codedrills.proto.user.Dashboard} returns this
*/
proto.io.codedrills.proto.user.Dashboard.prototype.setStrengthsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.io.codedrills.proto.user.TopicStatus=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.TopicStatus}
 */
proto.io.codedrills.proto.user.Dashboard.prototype.addStrengths = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.io.codedrills.proto.user.TopicStatus, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.Dashboard} returns this
 */
proto.io.codedrills.proto.user.Dashboard.prototype.clearStrengthsList = function() {
  return this.setStrengthsList([]);
};


/**
 * repeated TopicStatus weaknesses = 4;
 * @return {!Array<!proto.io.codedrills.proto.user.TopicStatus>}
 */
proto.io.codedrills.proto.user.Dashboard.prototype.getWeaknessesList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.user.TopicStatus>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.user.TopicStatus, 4));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.user.TopicStatus>} value
 * @return {!proto.io.codedrills.proto.user.Dashboard} returns this
*/
proto.io.codedrills.proto.user.Dashboard.prototype.setWeaknessesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.io.codedrills.proto.user.TopicStatus=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.TopicStatus}
 */
proto.io.codedrills.proto.user.Dashboard.prototype.addWeaknesses = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.io.codedrills.proto.user.TopicStatus, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.Dashboard} returns this
 */
proto.io.codedrills.proto.user.Dashboard.prototype.clearWeaknessesList = function() {
  return this.setWeaknessesList([]);
};


/**
 * repeated CodeAnalysis code_analysis = 5;
 * @return {!Array<!proto.io.codedrills.proto.user.CodeAnalysis>}
 */
proto.io.codedrills.proto.user.Dashboard.prototype.getCodeAnalysisList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.user.CodeAnalysis>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.user.CodeAnalysis, 5));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.user.CodeAnalysis>} value
 * @return {!proto.io.codedrills.proto.user.Dashboard} returns this
*/
proto.io.codedrills.proto.user.Dashboard.prototype.setCodeAnalysisList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.io.codedrills.proto.user.CodeAnalysis=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.CodeAnalysis}
 */
proto.io.codedrills.proto.user.Dashboard.prototype.addCodeAnalysis = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.io.codedrills.proto.user.CodeAnalysis, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.Dashboard} returns this
 */
proto.io.codedrills.proto.user.Dashboard.prototype.clearCodeAnalysisList = function() {
  return this.setCodeAnalysisList([]);
};


/**
 * repeated int32 recommended_problem_ids = 6;
 * @return {!Array<number>}
 */
proto.io.codedrills.proto.user.Dashboard.prototype.getRecommendedProblemIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.io.codedrills.proto.user.Dashboard} returns this
 */
proto.io.codedrills.proto.user.Dashboard.prototype.setRecommendedProblemIdsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.Dashboard} returns this
 */
proto.io.codedrills.proto.user.Dashboard.prototype.addRecommendedProblemIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.Dashboard} returns this
 */
proto.io.codedrills.proto.user.Dashboard.prototype.clearRecommendedProblemIdsList = function() {
  return this.setRecommendedProblemIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.user.DashboardView.repeatedFields_ = [2,3,4,5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.DashboardView.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.DashboardView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.DashboardView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.DashboardView.toObject = function(includeInstance, msg) {
  var f, obj = {
    overAllStatusView: (f = msg.getOverAllStatusView()) && proto.io.codedrills.proto.user.OverAllStatusView.toObject(includeInstance, f),
    inProgressDrillPreviewsList: jspb.Message.toObjectList(msg.getInProgressDrillPreviewsList(),
    io_codedrills_proto_content_view_pb.UserContentPreview.toObject, includeInstance),
    strengthsList: jspb.Message.toObjectList(msg.getStrengthsList(),
    proto.io.codedrills.proto.user.TopicStatusView.toObject, includeInstance),
    weaknessesList: jspb.Message.toObjectList(msg.getWeaknessesList(),
    proto.io.codedrills.proto.user.TopicStatusView.toObject, includeInstance),
    codeAnalysisList: jspb.Message.toObjectList(msg.getCodeAnalysisList(),
    proto.io.codedrills.proto.user.CodeAnalysisView.toObject, includeInstance),
    recommendedProblemPreviewsList: jspb.Message.toObjectList(msg.getRecommendedProblemPreviewsList(),
    io_codedrills_proto_content_view_pb.UserContentPreview.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.DashboardView}
 */
proto.io.codedrills.proto.user.DashboardView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.DashboardView;
  return proto.io.codedrills.proto.user.DashboardView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.DashboardView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.DashboardView}
 */
proto.io.codedrills.proto.user.DashboardView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.io.codedrills.proto.user.OverAllStatusView;
      reader.readMessage(value,proto.io.codedrills.proto.user.OverAllStatusView.deserializeBinaryFromReader);
      msg.setOverAllStatusView(value);
      break;
    case 2:
      var value = new io_codedrills_proto_content_view_pb.UserContentPreview;
      reader.readMessage(value,io_codedrills_proto_content_view_pb.UserContentPreview.deserializeBinaryFromReader);
      msg.addInProgressDrillPreviews(value);
      break;
    case 3:
      var value = new proto.io.codedrills.proto.user.TopicStatusView;
      reader.readMessage(value,proto.io.codedrills.proto.user.TopicStatusView.deserializeBinaryFromReader);
      msg.addStrengths(value);
      break;
    case 4:
      var value = new proto.io.codedrills.proto.user.TopicStatusView;
      reader.readMessage(value,proto.io.codedrills.proto.user.TopicStatusView.deserializeBinaryFromReader);
      msg.addWeaknesses(value);
      break;
    case 5:
      var value = new proto.io.codedrills.proto.user.CodeAnalysisView;
      reader.readMessage(value,proto.io.codedrills.proto.user.CodeAnalysisView.deserializeBinaryFromReader);
      msg.addCodeAnalysis(value);
      break;
    case 6:
      var value = new io_codedrills_proto_content_view_pb.UserContentPreview;
      reader.readMessage(value,io_codedrills_proto_content_view_pb.UserContentPreview.deserializeBinaryFromReader);
      msg.addRecommendedProblemPreviews(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.DashboardView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.DashboardView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.DashboardView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.DashboardView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOverAllStatusView();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.io.codedrills.proto.user.OverAllStatusView.serializeBinaryToWriter
    );
  }
  f = message.getInProgressDrillPreviewsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      io_codedrills_proto_content_view_pb.UserContentPreview.serializeBinaryToWriter
    );
  }
  f = message.getStrengthsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.io.codedrills.proto.user.TopicStatusView.serializeBinaryToWriter
    );
  }
  f = message.getWeaknessesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.io.codedrills.proto.user.TopicStatusView.serializeBinaryToWriter
    );
  }
  f = message.getCodeAnalysisList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.io.codedrills.proto.user.CodeAnalysisView.serializeBinaryToWriter
    );
  }
  f = message.getRecommendedProblemPreviewsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      io_codedrills_proto_content_view_pb.UserContentPreview.serializeBinaryToWriter
    );
  }
};


/**
 * optional OverAllStatusView over_all_status_view = 1;
 * @return {?proto.io.codedrills.proto.user.OverAllStatusView}
 */
proto.io.codedrills.proto.user.DashboardView.prototype.getOverAllStatusView = function() {
  return /** @type{?proto.io.codedrills.proto.user.OverAllStatusView} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.OverAllStatusView, 1));
};


/**
 * @param {?proto.io.codedrills.proto.user.OverAllStatusView|undefined} value
 * @return {!proto.io.codedrills.proto.user.DashboardView} returns this
*/
proto.io.codedrills.proto.user.DashboardView.prototype.setOverAllStatusView = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.DashboardView} returns this
 */
proto.io.codedrills.proto.user.DashboardView.prototype.clearOverAllStatusView = function() {
  return this.setOverAllStatusView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.DashboardView.prototype.hasOverAllStatusView = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated io.codedrills.proto.content.UserContentPreview in_progress_drill_previews = 2;
 * @return {!Array<!proto.io.codedrills.proto.content.UserContentPreview>}
 */
proto.io.codedrills.proto.user.DashboardView.prototype.getInProgressDrillPreviewsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.UserContentPreview>} */ (
    jspb.Message.getRepeatedWrapperField(this, io_codedrills_proto_content_view_pb.UserContentPreview, 2));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.UserContentPreview>} value
 * @return {!proto.io.codedrills.proto.user.DashboardView} returns this
*/
proto.io.codedrills.proto.user.DashboardView.prototype.setInProgressDrillPreviewsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.UserContentPreview=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.UserContentPreview}
 */
proto.io.codedrills.proto.user.DashboardView.prototype.addInProgressDrillPreviews = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.io.codedrills.proto.content.UserContentPreview, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.DashboardView} returns this
 */
proto.io.codedrills.proto.user.DashboardView.prototype.clearInProgressDrillPreviewsList = function() {
  return this.setInProgressDrillPreviewsList([]);
};


/**
 * repeated TopicStatusView strengths = 3;
 * @return {!Array<!proto.io.codedrills.proto.user.TopicStatusView>}
 */
proto.io.codedrills.proto.user.DashboardView.prototype.getStrengthsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.user.TopicStatusView>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.user.TopicStatusView, 3));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.user.TopicStatusView>} value
 * @return {!proto.io.codedrills.proto.user.DashboardView} returns this
*/
proto.io.codedrills.proto.user.DashboardView.prototype.setStrengthsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.io.codedrills.proto.user.TopicStatusView=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.TopicStatusView}
 */
proto.io.codedrills.proto.user.DashboardView.prototype.addStrengths = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.io.codedrills.proto.user.TopicStatusView, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.DashboardView} returns this
 */
proto.io.codedrills.proto.user.DashboardView.prototype.clearStrengthsList = function() {
  return this.setStrengthsList([]);
};


/**
 * repeated TopicStatusView weaknesses = 4;
 * @return {!Array<!proto.io.codedrills.proto.user.TopicStatusView>}
 */
proto.io.codedrills.proto.user.DashboardView.prototype.getWeaknessesList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.user.TopicStatusView>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.user.TopicStatusView, 4));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.user.TopicStatusView>} value
 * @return {!proto.io.codedrills.proto.user.DashboardView} returns this
*/
proto.io.codedrills.proto.user.DashboardView.prototype.setWeaknessesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.io.codedrills.proto.user.TopicStatusView=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.TopicStatusView}
 */
proto.io.codedrills.proto.user.DashboardView.prototype.addWeaknesses = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.io.codedrills.proto.user.TopicStatusView, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.DashboardView} returns this
 */
proto.io.codedrills.proto.user.DashboardView.prototype.clearWeaknessesList = function() {
  return this.setWeaknessesList([]);
};


/**
 * repeated CodeAnalysisView code_analysis = 5;
 * @return {!Array<!proto.io.codedrills.proto.user.CodeAnalysisView>}
 */
proto.io.codedrills.proto.user.DashboardView.prototype.getCodeAnalysisList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.user.CodeAnalysisView>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.user.CodeAnalysisView, 5));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.user.CodeAnalysisView>} value
 * @return {!proto.io.codedrills.proto.user.DashboardView} returns this
*/
proto.io.codedrills.proto.user.DashboardView.prototype.setCodeAnalysisList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.io.codedrills.proto.user.CodeAnalysisView=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.CodeAnalysisView}
 */
proto.io.codedrills.proto.user.DashboardView.prototype.addCodeAnalysis = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.io.codedrills.proto.user.CodeAnalysisView, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.DashboardView} returns this
 */
proto.io.codedrills.proto.user.DashboardView.prototype.clearCodeAnalysisList = function() {
  return this.setCodeAnalysisList([]);
};


/**
 * repeated io.codedrills.proto.content.UserContentPreview recommended_problem_previews = 6;
 * @return {!Array<!proto.io.codedrills.proto.content.UserContentPreview>}
 */
proto.io.codedrills.proto.user.DashboardView.prototype.getRecommendedProblemPreviewsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.UserContentPreview>} */ (
    jspb.Message.getRepeatedWrapperField(this, io_codedrills_proto_content_view_pb.UserContentPreview, 6));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.UserContentPreview>} value
 * @return {!proto.io.codedrills.proto.user.DashboardView} returns this
*/
proto.io.codedrills.proto.user.DashboardView.prototype.setRecommendedProblemPreviewsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.UserContentPreview=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.UserContentPreview}
 */
proto.io.codedrills.proto.user.DashboardView.prototype.addRecommendedProblemPreviews = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.io.codedrills.proto.content.UserContentPreview, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.DashboardView} returns this
 */
proto.io.codedrills.proto.user.DashboardView.prototype.clearRecommendedProblemPreviewsList = function() {
  return this.setRecommendedProblemPreviewsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.TopicStatusView.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.TopicStatusView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.TopicStatusView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.TopicStatusView.toObject = function(includeInstance, msg) {
  var f, obj = {
    drillPreview: (f = msg.getDrillPreview()) && io_codedrills_proto_content_view_pb.UserContentPreview.toObject(includeInstance, f),
    userLevel: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.TopicStatusView}
 */
proto.io.codedrills.proto.user.TopicStatusView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.TopicStatusView;
  return proto.io.codedrills.proto.user.TopicStatusView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.TopicStatusView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.TopicStatusView}
 */
proto.io.codedrills.proto.user.TopicStatusView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_view_pb.UserContentPreview;
      reader.readMessage(value,io_codedrills_proto_content_view_pb.UserContentPreview.deserializeBinaryFromReader);
      msg.setDrillPreview(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserLevel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.TopicStatusView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.TopicStatusView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.TopicStatusView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.TopicStatusView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDrillPreview();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_view_pb.UserContentPreview.serializeBinaryToWriter
    );
  }
  f = message.getUserLevel();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional io.codedrills.proto.content.UserContentPreview drill_preview = 1;
 * @return {?proto.io.codedrills.proto.content.UserContentPreview}
 */
proto.io.codedrills.proto.user.TopicStatusView.prototype.getDrillPreview = function() {
  return /** @type{?proto.io.codedrills.proto.content.UserContentPreview} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_view_pb.UserContentPreview, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.UserContentPreview|undefined} value
 * @return {!proto.io.codedrills.proto.user.TopicStatusView} returns this
*/
proto.io.codedrills.proto.user.TopicStatusView.prototype.setDrillPreview = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.TopicStatusView} returns this
 */
proto.io.codedrills.proto.user.TopicStatusView.prototype.clearDrillPreview = function() {
  return this.setDrillPreview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.TopicStatusView.prototype.hasDrillPreview = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 user_level = 2;
 * @return {number}
 */
proto.io.codedrills.proto.user.TopicStatusView.prototype.getUserLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.TopicStatusView} returns this
 */
proto.io.codedrills.proto.user.TopicStatusView.prototype.setUserLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.CodeAnalysisView.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.CodeAnalysisView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.CodeAnalysisView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CodeAnalysisView.toObject = function(includeInstance, msg) {
  var f, obj = {
    drillPreview: (f = msg.getDrillPreview()) && io_codedrills_proto_content_view_pb.UserContentPreview.toObject(includeInstance, f),
    userLevel: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.CodeAnalysisView}
 */
proto.io.codedrills.proto.user.CodeAnalysisView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.CodeAnalysisView;
  return proto.io.codedrills.proto.user.CodeAnalysisView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.CodeAnalysisView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.CodeAnalysisView}
 */
proto.io.codedrills.proto.user.CodeAnalysisView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_view_pb.UserContentPreview;
      reader.readMessage(value,io_codedrills_proto_content_view_pb.UserContentPreview.deserializeBinaryFromReader);
      msg.setDrillPreview(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserLevel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.CodeAnalysisView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.CodeAnalysisView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.CodeAnalysisView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CodeAnalysisView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDrillPreview();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_view_pb.UserContentPreview.serializeBinaryToWriter
    );
  }
  f = message.getUserLevel();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional io.codedrills.proto.content.UserContentPreview drill_preview = 1;
 * @return {?proto.io.codedrills.proto.content.UserContentPreview}
 */
proto.io.codedrills.proto.user.CodeAnalysisView.prototype.getDrillPreview = function() {
  return /** @type{?proto.io.codedrills.proto.content.UserContentPreview} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_view_pb.UserContentPreview, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.UserContentPreview|undefined} value
 * @return {!proto.io.codedrills.proto.user.CodeAnalysisView} returns this
*/
proto.io.codedrills.proto.user.CodeAnalysisView.prototype.setDrillPreview = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.CodeAnalysisView} returns this
 */
proto.io.codedrills.proto.user.CodeAnalysisView.prototype.clearDrillPreview = function() {
  return this.setDrillPreview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.CodeAnalysisView.prototype.hasDrillPreview = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 user_level = 2;
 * @return {number}
 */
proto.io.codedrills.proto.user.CodeAnalysisView.prototype.getUserLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.CodeAnalysisView} returns this
 */
proto.io.codedrills.proto.user.CodeAnalysisView.prototype.setUserLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.OverAllStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.OverAllStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.OverAllStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.OverAllStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    easy: jspb.Message.getFieldWithDefault(msg, 1, 0),
    medium: jspb.Message.getFieldWithDefault(msg, 2, 0),
    hard: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.OverAllStatus}
 */
proto.io.codedrills.proto.user.OverAllStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.OverAllStatus;
  return proto.io.codedrills.proto.user.OverAllStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.OverAllStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.OverAllStatus}
 */
proto.io.codedrills.proto.user.OverAllStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEasy(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMedium(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHard(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.OverAllStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.OverAllStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.OverAllStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.OverAllStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEasy();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMedium();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getHard();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 easy = 1;
 * @return {number}
 */
proto.io.codedrills.proto.user.OverAllStatus.prototype.getEasy = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.OverAllStatus} returns this
 */
proto.io.codedrills.proto.user.OverAllStatus.prototype.setEasy = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 medium = 2;
 * @return {number}
 */
proto.io.codedrills.proto.user.OverAllStatus.prototype.getMedium = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.OverAllStatus} returns this
 */
proto.io.codedrills.proto.user.OverAllStatus.prototype.setMedium = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 hard = 3;
 * @return {number}
 */
proto.io.codedrills.proto.user.OverAllStatus.prototype.getHard = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.OverAllStatus} returns this
 */
proto.io.codedrills.proto.user.OverAllStatus.prototype.setHard = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.OverAllStatusView.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.OverAllStatusView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.OverAllStatusView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.OverAllStatusView.toObject = function(includeInstance, msg) {
  var f, obj = {
    easy: jspb.Message.getFieldWithDefault(msg, 1, 0),
    medium: jspb.Message.getFieldWithDefault(msg, 2, 0),
    hard: jspb.Message.getFieldWithDefault(msg, 3, 0),
    total: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.OverAllStatusView}
 */
proto.io.codedrills.proto.user.OverAllStatusView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.OverAllStatusView;
  return proto.io.codedrills.proto.user.OverAllStatusView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.OverAllStatusView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.OverAllStatusView}
 */
proto.io.codedrills.proto.user.OverAllStatusView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEasy(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMedium(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHard(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.OverAllStatusView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.OverAllStatusView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.OverAllStatusView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.OverAllStatusView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEasy();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMedium();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getHard();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional int32 easy = 1;
 * @return {number}
 */
proto.io.codedrills.proto.user.OverAllStatusView.prototype.getEasy = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.OverAllStatusView} returns this
 */
proto.io.codedrills.proto.user.OverAllStatusView.prototype.setEasy = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 medium = 2;
 * @return {number}
 */
proto.io.codedrills.proto.user.OverAllStatusView.prototype.getMedium = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.OverAllStatusView} returns this
 */
proto.io.codedrills.proto.user.OverAllStatusView.prototype.setMedium = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 hard = 3;
 * @return {number}
 */
proto.io.codedrills.proto.user.OverAllStatusView.prototype.getHard = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.OverAllStatusView} returns this
 */
proto.io.codedrills.proto.user.OverAllStatusView.prototype.setHard = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 total = 4;
 * @return {number}
 */
proto.io.codedrills.proto.user.OverAllStatusView.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.OverAllStatusView} returns this
 */
proto.io.codedrills.proto.user.OverAllStatusView.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.TopicStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.TopicStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.TopicStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.TopicStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    drillId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    userLevel: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.TopicStatus}
 */
proto.io.codedrills.proto.user.TopicStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.TopicStatus;
  return proto.io.codedrills.proto.user.TopicStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.TopicStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.TopicStatus}
 */
proto.io.codedrills.proto.user.TopicStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDrillId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserLevel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.TopicStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.TopicStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.TopicStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.TopicStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDrillId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getUserLevel();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 drill_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.user.TopicStatus.prototype.getDrillId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.TopicStatus} returns this
 */
proto.io.codedrills.proto.user.TopicStatus.prototype.setDrillId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 user_level = 2;
 * @return {number}
 */
proto.io.codedrills.proto.user.TopicStatus.prototype.getUserLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.TopicStatus} returns this
 */
proto.io.codedrills.proto.user.TopicStatus.prototype.setUserLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.CodeAnalysis.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.CodeAnalysis.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.CodeAnalysis} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CodeAnalysis.toObject = function(includeInstance, msg) {
  var f, obj = {
    drillId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    userLevel: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.CodeAnalysis}
 */
proto.io.codedrills.proto.user.CodeAnalysis.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.CodeAnalysis;
  return proto.io.codedrills.proto.user.CodeAnalysis.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.CodeAnalysis} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.CodeAnalysis}
 */
proto.io.codedrills.proto.user.CodeAnalysis.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDrillId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserLevel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.CodeAnalysis.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.CodeAnalysis.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.CodeAnalysis} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CodeAnalysis.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDrillId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getUserLevel();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 drill_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.user.CodeAnalysis.prototype.getDrillId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.CodeAnalysis} returns this
 */
proto.io.codedrills.proto.user.CodeAnalysis.prototype.setDrillId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 user_level = 2;
 * @return {number}
 */
proto.io.codedrills.proto.user.CodeAnalysis.prototype.getUserLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.CodeAnalysis} returns this
 */
proto.io.codedrills.proto.user.CodeAnalysis.prototype.setUserLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


goog.object.extend(exports, proto.io.codedrills.proto.user);
